import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Headers} from '@angular/http';
import {ServiceConfig} from './service-config';
import { HttpClient } from '@angular/common/http';
@Injectable()
export class DiscussionProjectsService {

  private host = ServiceConfig.host;
  public baseUrl = this.host + '/api/discussionProjects/';
  // public baseUrl = 'http://localhost/api/projects/';
  public data: any;
  public headers: Headers;

  constructor(private http: HttpClient) {
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
  
  }

  

  public index(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url,body);
  }

  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'create?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }



  public update(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'update?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public delete(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/discussionProjects.service.ts